import {
    FLATBACK_THRESHOLD_DEGREES,
    PPT_THRESHOLD,
    type HipSpineClassification,
} from './hipSpineClassification';

/**
 * Pure display formatters for the hip-spine warning threshold texts.
 *
 * The comparison always states the condition strictly (`<` / `>`), never with
 * equality signs — the measured angles can't justify equality-level certainty.
 */

/** Degrees for clinical display: a typographic minus (−), never a hyphen. */
function degrees(value: number): string {
    return `${value}°`.replace('-', '−');
}

export function flatbackThresholdText(detected: boolean): string {
    return `PI − LL ${detected ? '>' : '<'} ${degrees(FLATBACK_THRESHOLD_DEGREES)}`;
}

export function pptThresholdText(detected: boolean): string {
    return `APPt ${detected ? '<' : '>'} ${degrees(PPT_THRESHOLD)}`;
}

export interface StiffWarningContent {
    detected: boolean;
    thresholdText: string;
}

/** Stiff-spine card content, or null when stiffness was not measurable. */
export function stiffWarningContent(
    classification: HipSpineClassification,
): StiffWarningContent | null {
    if (classification.stiff === null) return null;
    const { stiff, stiffMetricAbbreviation, stiffThresholdDegrees } = classification;
    return {
        detected: stiff,
        thresholdText: `${stiffMetricAbbreviation} ${stiff ? '<' : '>'} ${degrees(stiffThresholdDegrees)}`,
    };
}
